import { memo, useCallback, useState } from 'react';

const RenderReferences = ({
    references = [],
    withCategory,
    approved = true,
    removeReference = () => null,
}) => {
    const [tooltipOpen, setTooltipOpen] = useState(() => {
        let obj = {};
        if (references?.length > 0) {
            references?.forEach((ref, idx) => {
                obj[`ref-${idx}`] = false;
            });
        }
        return obj;
    });

    const handleTooltip = useCallback((idx, val) => {
        setTooltipOpen((prevVal) => ({
            ...prevVal,
            [`ref-${idx}`]: val,
        }));
    }, []);

    if (!references?.length) return null;

    return references.map((ref, idx) => {
        const key = ref?._id ?? ref;
        const value = ref?.reference ?? ref;
        const category = withCategory && ref?.category;

        return (
            <div
                key={key}
                data-test={`chosenRef-${value}`}
                style={{cursor: 'pointer'}}
                className='position-relative d-inline-block p-2'
                onClick={() => !approved && removeReference(ref)}
                onMouseOver={() => handleTooltip(idx, true)}
                onMouseLeave={() => handleTooltip(idx, false)}
                title={approved ? `Referenz: ${value}` : 'Zum Entfernen anklicken!'}
            >
                {!approved && tooltipOpen[`ref-${idx}`] && (
                    <div
                        style={{ right: -24, top: -4, zIndex: -1 }}
                        className='position-absolute btn'
                    >
                        <i
                            className='fa fa-times-circle fa-lg text-danger'
                            aria-hidden='true'
                        />
                    </div>
                )}
                <div className='btn btn-outline-success rounded-pill'>
                    <p className='m-0'>
                        {value} <span>{category && ` - ${category}`}</span>
                    </p>
                </div>
            </div>
        );
    });
};

export default memo(RenderReferences);
